if (typeof mgxJSON !== "object") {
    mgxJSON = {}
}(function() {
    "use strict";

    function f(e) {
        return e < 10 ? "0" + e : e
    }

    function quote(e) {
        escapable.lastIndex = 0;
        return escapable.test(e) ? '"' + e.replace(escapable, function(e) {
            var t = meta[e];
            return typeof t === "string" ? t : "\\u" + ("0000" + e.charCodeAt(0).toString(16)).slice(-4)
        }) + '"' : '"' + e + '"'
    }

    function str(e, t) {
        var n, r, i, s, o = gap,
            u, a = t[e];
        if (a && typeof a === "object" && typeof a.toJSON === "function") {
            a = a.toJSON(e)
        }
        if (typeof rep === "function") {
            a = rep.call(t, e, a)
        }
        switch (typeof a) {
            case "string":
                return quote(a);
            case "number":
                return isFinite(a) ? String(a) : "null";
            case "boolean":
            case "null":
                return String(a);
            case "object":
                if (!a) {
                    return "null"
                }
                gap += indent;
                u = [];
                if (Object.prototype.toString.apply(a) === "[object Array]") {
                    s = a.length;
                    for (n = 0; n < s; n += 1) {
                        u[n] = str(n, a) || "null"
                    }
                    i = u.length === 0 ? "[]" : gap ? "[\n" + gap + u.join(",\n" + gap) + "\n" + o + "]" : "[" + u.join(",") + "]";
                    gap = o;
                    return i
                }
                if (rep && typeof rep === "object") {
                    s = rep.length;
                    for (n = 0; n < s; n += 1) {
                        if (typeof rep[n] === "string") {
                            r = rep[n];
                            i = str(r, a);
                            if (i) {
                                u.push(quote(r) + (gap ? ": " : ":") + i)
                            }
                        }
                    }
                } else {
                    for (r in a) {
                        if (Object.prototype.hasOwnProperty.call(a, r)) {
                            i = str(r, a);
                            if (i) {
                                u.push(quote(r) + (gap ? ": " : ":") + i)
                            }
                        }
                    }
                }
                i = u.length === 0 ? "{}" : gap ? "{\n" + gap + u.join(",\n" + gap) + "\n" + o + "}" : "{" + u.join(",") + "}";
                gap = o;
                return i
        }
    }
    if (typeof Date.prototype.toJSON !== "function") {
        Date.prototype.toJSON = function(e) {
            return isFinite(this.valueOf()) ? this.getUTCFullYear() + "-" + f(this.getUTCMonth() + 1) + "-" + f(this.getUTCDate()) + "T" + f(this.getUTCHours()) + ":" + f(this.getUTCMinutes()) + ":" + f(this.getUTCSeconds()) + "Z" : null
        };
        String.prototype.toJSON = Number.prototype.toJSON = Boolean.prototype.toJSON = function(e) {
            return this.valueOf()
        }
    }
    var cx = /[\u0000\u00ad\u0600-\u0604\u070f\u17b4\u17b5\u200c-\u200f\u2028-\u202f\u2060-\u206f\ufeff\ufff0-\uffff]/g,
        escapable = /[\\\"\x00-\x1f\x7f-\x9f\u00ad\u0600-\u0604\u070f\u17b4\u17b5\u200c-\u200f\u2028-\u202f\u2060-\u206f\ufeff\ufff0-\uffff]/g,
        gap, indent, meta = {
            "\b": "\\b",
            "	": "\\t",
            "\n": "\\n",
            "\f": "\\f",
            "\r": "\\r",
            '"': '\\"',
            "\\": "\\\\"
        },
        rep;
    if (typeof mgxJSON.stringify !== "function") {
        mgxJSON.stringify = function(e, t, n) {
            var r;
            gap = "";
            indent = "";
            if (typeof n === "number") {
                for (r = 0; r < n; r += 1) {
                    indent += " "
                }
            } else if (typeof n === "string") {
                indent = n
            }
            rep = t;
            if (t && typeof t !== "function" && (typeof t !== "object" || typeof t.length !== "number")) {
                throw new Error("mgxJSON.stringify")
            }
            return str("", {
                "": e
            })
        }
    }
    if (typeof mgxJSON.parse !== "function") {
        mgxJSON.parse = function(text, reviver) {
            function walk(e, t) {
                var n, r, i = e[t];
                if (i && typeof i === "object") {
                    for (n in i) {
                        if (Object.prototype.hasOwnProperty.call(i, n)) {
                            r = walk(i, n);
                            if (r !== undefined) {
                                i[n] = r
                            } else {
                                delete i[n]
                            }
                        }
                    }
                }
                return reviver.call(e, t, i)
            }
            var j;
            text = String(text);
            cx.lastIndex = 0;
            if (cx.test(text)) {
                text = text.replace(cx, function(e) {
                    return "\\u" + ("0000" + e.charCodeAt(0).toString(16)).slice(-4)
                })
            }
            if (/^[\],:{}\s]*$/.test(text.replace(/\\(?:["\\\/bfnrt]|u[0-9a-fA-F]{4})/g, "@").replace(/"[^"\\\n\r]*"|true|false|null|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?/g, "]").replace(/(?:^|:|,)(?:\s*\[)+/g, ""))) {
                j = eval("(" + text + ")");
                return typeof reviver === "function" ? walk({
                    "": j
                }, "") : j
            }
            throw new SyntaxError("mgxJSON.parse")
        }
    }
})();
(function() {
    function e(e, t, n) {
        var r = t && n || 0,
            i = 0;
        t = t || [];
        e.toLowerCase().replace(/[0-9a-f]{2}/g, function(e) {
            if (i < 16) {
                t[r + i++] = h[e]
            }
        });
        while (i < 16) {
            t[r + i++] = 0
        }
        return t
    }

    function t(e, t) {
        var n = t || 0,
            r = c;
        return r[e[n++]] + r[e[n++]] + r[e[n++]] + r[e[n++]] + "-" + r[e[n++]] + r[e[n++]] + "-" + r[e[n++]] + r[e[n++]] + "-" + r[e[n++]] + r[e[n++]] + "-" + r[e[n++]] + r[e[n++]] + r[e[n++]] + r[e[n++]] + r[e[n++]] + r[e[n++]]
    }

    function n(e, n, r) {
        var i = n && r || 0;
        var s = n || [];
        e = e || {};
        var o = e.clockseq != null ? e.clockseq : m;
        var u = e.msecs != null ? e.msecs : (new Date).getTime();
        var a = e.nsecs != null ? e.nsecs : y + 1;
        var f = u - g + (a - y) / 1e4;
        if (f < 0 && e.clockseq == null) {
            o = o + 1 & 16383
        }
        if ((f < 0 || u > g) && e.nsecs == null) {
            a = 0
        }
        if (a >= 1e4) {
            throw new Error("mgxUuid.v1(): Can't create more than 10M uuids/sec")
        }
        g = u;
        y = a;
        m = o;
        u += 122192928e5;
        var l = ((u & 268435455) * 1e4 + a) % 4294967296;
        s[i++] = l >>> 24 & 255;
        s[i++] = l >>> 16 & 255;
        s[i++] = l >>> 8 & 255;
        s[i++] = l & 255;
        var c = u / 4294967296 * 1e4 & 268435455;
        s[i++] = c >>> 8 & 255;
        s[i++] = c & 255;
        s[i++] = c >>> 24 & 15 | 16;
        s[i++] = c >>> 16 & 255;
        s[i++] = o >>> 8 | 128;
        s[i++] = o & 255;
        var h = e.node || v;
        for (var p = 0; p < 6; p++) {
            s[i + p] = h[p]
        }
        return n ? n : t(s)
    }

    function r(e, n, r) {
        var i = n && r || 0;
        if (typeof e == "string") {
            n = e == "binary" ? new l(16) : null;
            e = null
        }
        e = e || {};
        var o = e.random || (e.rng || s)();
        o[6] = o[6] & 15 | 64;
        o[8] = o[8] & 63 | 128;
        if (n) {
            for (var u = 0; u < 16; u++) {
                n[i + u] = o[u]
            }
        }
        return n || t(o)
    }
    var i = this;
    var s;
    if (typeof require == "function") {
        try {
            var o = require("crypto").randomBytes;
            s = o && function() {
                return o(16)
            }
        } catch (u) {}
    }
    if (!s && i.crypto && crypto.getRandomValues) {
        var a = new Uint8Array(16);
        s = function() {
            crypto.getRandomValues(a);
            return a
        }
    }
    if (!s) {
        var f = new Array(16);
        s = function() {
            for (var e = 0, t; e < 16; e++) {
                if ((e & 3) === 0) t = Math.random() * 4294967296;
                f[e] = t >>> ((e & 3) << 3) & 255
            }
            return f
        }
    }
    var l = typeof Buffer == "function" ? Buffer : Array;
    var c = [];
    var h = {};
    for (var p = 0; p < 256; p++) {
        c[p] = (p + 256).toString(16).substr(1);
        h[c[p]] = p
    }
    var d = s();
    var v = [d[0] | 1, d[1], d[2], d[3], d[4], d[5]];
    var m = (d[6] << 8 | d[7]) & 16383;
    var g = 0,
        y = 0;
    var b = r;
    b.v1 = n;
    b.v4 = r;
    b.parse = e;
    b.unparse = t;
    b.BufferClass = l;
    if (i.define && define.amd) {
        define(function() {
            return b
        })
    } else if (typeof module != "undefined" && module.exports) {
        module.exports = b
    } else {
        var w = i.mgxUuid;
        b.noConflict = function() {
            i.mgxUuid = w;
            return b
        };
        i.mgxUuid = b
    }
}).call(this);
if (typeof MGX !== "object") {
    MGX = {
        PageLoadId: "",
        Sequence: 0,
        AccessKey: "",
        VisitorId: "",
        MgxVisitorId: "",
        NewSession: "",
        Keycode: "",
        Uid: "",
        Eid: "",
        Sid: "",
        Utm: {
            utm_source: "",
            utm_medium: "",
            utm_campaign: "",
            utm_keyword: "",
            utm_term: "",
            utm_content: ""
        },
        Url: document.URL,
        Referrer: document.referrer,
        Navigator: {
            AppCodeName: navigator.appCodeName,
            AppName: navigator.appName,
            AppVersion: navigator.appVersion,
            CookieEnabled: navigator.cookieEnabled,
            OnLine: navigator.onLine,
            Platform: navigator.platform,
            UserAgent: navigator.userAgent
        },
        Version: "1.1"
    }
}
if (typeof MGX.GetCookie !== "function") {
    MGX.GetCookie = function(e) {
        var t, n, r, i = document.cookie.split(";");
        for (t = 0; t < i.length; t++) {
            n = i[t].substr(0, i[t].indexOf("="));
            r = i[t].substr(i[t].indexOf("=") + 1);
            n = n.replace(/^\s+|\s+$/g, "");
            if (n == e) {
                return unescape(r)
            }
        }
    }
}
if (typeof MGX.SetCookie !== "function") {
    MGX.SetCookie = function(e, t, n) {
        var r = new Date;
        r.setDate(r.getDate() + n);
        var i = escape(t) + "; path=/" + (n == null ? "" : "; expires=" + r.toUTCString());
        document.cookie = e + "=" + i
    }
}
if (typeof MGX.GetParameter !== "function") {
    MGX.GetParameter = function(e) {
        e = e.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
        var t = "[\\?&]" + e + "=([^&#]*)";
        var n = new RegExp(t);
        var r = n.exec(window.location.search);
        if (r == null) return "";
        else return decodeURIComponent(r[1].replace(/\+/g, " "))
    }
}
if (typeof MGX.IsDefined !== "function") {
    MGX.IsDefined = function(e) {
        if (typeof e === "undefined") {
            e = ""
        }
        return e
    }
}
if (typeof MGX.ServiceUrl !== "function") {
    MGX.ServiceUrl = function(e) {
        return "//api.universalcookie.com/" + e + "/"
	  //return "//54.191.18.233/" + e + "/"
	  
    }
}
if (typeof MGX.ServiceAction !== "function") {
    MGX.ServiceAction = function(e, t, n, r) {
        if (t == "" || t == null) {
            t = MGX.GetCookie("MGX_P");
            if (typeof t === "undefined") t = ""
        }
        var i = MGX.ServiceUrl(n) + e + (t != "" ? "/" + t : "") + r + "&jsoncallback=?";
        jQuery.getJSON(i, function(e) {
            return e
        })
    }
}
if (typeof MGX.SetUtm !== "function") {
    MGX.SetUtm = function() {
        MGX.Utm.utm_source = MGX.GetParameter("utm_source");
        MGX.Utm.utm_medium = MGX.GetParameter("utm_medium");
        MGX.Utm.utm_campaign = MGX.GetParameter("utm_campaign");
        MGX.Utm.utm_keyword = MGX.GetParameter("utm_keyword");
        MGX.Utm.utm_term = MGX.GetParameter("utm_term");
        MGX.Utm.utm_content = MGX.GetParameter("utm_content");
        return
    }
}
if (typeof MGX.Init !== "function") {
    MGX.Init = function() {
        var e = MGX.IsDefined(MGX.GetCookie("MGX_P"));
        var t = MGX.IsDefined(MGX.GetCookie("MGX_U"));
        var n = MGX.IsDefined(MGX.GetCookie("MGX_PX"));
        if (e == "") e = mgxUuid.v1();
        if (t == "") t = mgxUuid.v1();
        MGX.VisitorId = e;
        MGX.MgxVisitorId = t;
        MGX.NewSession = n == "" ? "1" : "0";
        MGX.PageLoadId = mgxUuid.v1();
        MGX.SetUtm();
        return
    }
};
MGX.Init();
if (typeof MGX.CleanRawData !== "function") {
    MGX.CleanRawData = function(e) {
        jQuery.each(e, function(t, n) {
            if (t === "CartItems") {
                jQuery.each(n, function(r, i) {
                    jQuery.each(i, function(f, s) {
                        i[f] = encodeURIComponent(MGX.IsDefined(s)).replace(/%22/g, "%5C%22");
                    })
                })
            } else {
                e[t] = encodeURIComponent(MGX.IsDefined(n))
            }
        });
        return e
    }
}
if (typeof MGX.Commit !== "function") {
    MGX.Commit = function(e) {
        var sk = false;
        if (e.Label == "Contact") {
            if (e.EmailAddress === "undefined") {
                sk = true;
            }
            if (e.EmailAddress == "") {
                sk = true;
            }
        }
        if (sk == false) {
            e = MGX.CleanRawData(e);
            var t = {
                NewSession: MGX.NewSession,
                Keycode: MGX.Keycode,
                Uid: MGX.Uid,
                Eid: MGX.Eid,
                Sid: MGX.Sid,
                Utm: MGX.Utm,
                Referrer: encodeURIComponent(MGX.Referrer.replace("\"", "")),
                Navigator: MGX.Navigator,
                RawData: e
            };
            var n = MGX.Sequence++;
            var r = "?" + (MGX.VisitorId != "" ? "visitorid=" + MGX.VisitorId + "&" : "") + (MGX.MgxVisitorId != "" ? "mgxvisitorid=" + MGX.MgxVisitorId + "&" : "") + (MGX.PageLoadId != "" ? "pageloadid=" + MGX.PageLoadId + "&" : "") + (e.Method != "" ? "method=" + e.Label + "&" : "") + "ver=" + MGX.Version + "&" + "sequence=" + n + "&" + "rawdata=" + mgxJSON.stringify(t) + "&" + (MGX.Url != "" ? "url=" + encodeURIComponent(MGX.Url) + "&" : "");
            var i = MGX.ServiceUrl("C/RawData") + MGX.AccessKey + r + "jsoncallback=?";
            jQuery.getJSON(i, function(e) {
                if (e.Status == "true") {
                    MGX.SetCookie("MGX_P", e.VisitorId, 365);
                    MGX.SetCookie("MGX_U", e.MgxVisitorId, 365);
                    if (MGX.NewSession == "1") MGX.SetCookie("MGX_PX", e.VisitorId, null)
                }
            });
            return i
        }
    }
}
if (typeof MGX.P !== "function") {
    MGX.P = function(e, t, n, r, i) {
        var s = MGX.GetCookie("MGX_P");
        var o = MGX.GetCookie("MGX_PX");
        if (typeof s === "undefined") s = "";
        if (typeof o === "undefined") o = "";
        if (typeof t === "undefined") t = "";
        if (typeof n === "undefined") n = "";
        if (typeof r === "undefined") r = "";
        if (typeof i === "undefined") i = "";
        var u = "utm_source:" + MGX.GetParameter("utm_source") + "|utm_medium:" + MGX.GetParameter("utm_medium") + "|utm_campaign:" + MGX.GetParameter("utm_campaign") + "|utm_keyword:" + MGX.GetParameter("utm_keyword");
        if (u == "utm_source:|utm_medium:|utm_campaign:|utm_keyword:") u = "";
        var a = "?" + (o == "" ? "newsession=1&" : "") + (t != "" ? "keycode=" + t + "&" : "") + (r != "" ? "sid=" + r + "&" : "") + (i != "" ? "uid=" + i + "&" : "") + (n != "" ? "eid=" + n + "&" : "") + (u != "" ? "utm=" + u + "&" : "");
        var f = MGX.ServiceUrl("P/LogVisit") + e + (s != "" ? "/" + s : "") + a + "jsoncallback=?";
        jQuery.getJSON(f, function(s) {
            if (s.Status == "true") {
                MGX.SetCookie("MGX_P", s.CookieId, 365);
                if (o == "") MGX.SetCookie("MGX_PX", s.CookieId, null);
                MGX.U(e, s.CookieId, t, n, r, i);
                if (typeof MGX_Queue === "function") MGX_Queue(e, s.CookieId)
            }
        })
    }
}
if (typeof MGX.U !== "function") {
    MGX.U = function(e, t, n, r, i, s) {
        if (typeof t === "undefined") t = "";
        if (typeof n === "undefined") n = "";
        if (typeof r === "undefined") r = "";
        if (typeof i === "undefined") i = "";
        if (typeof s === "undefined") s = "";
        var o = "?" + (n != "" ? "keycode=" + n + "&" : "") + (i != "" ? "sid=" + i + "&" : "") + (s != "" ? "uid=" + s + "&" : "") + (r != "" ? "eid=" + r + "&" : "");
        var u = MGX.ServiceUrl("U") + e + (t != "" ? "/" + t : "") + o + "jsoncallback=?";
        jQuery.getJSON(u, function(e) {
            if (e.Status == "true") {
                MGX.SetCookie("MGX_U", e.CookieId, 365)
            }
        })
    }
}
if (typeof MGX.Customer !== "function") {
    MGX.Customer = function(e, t) {
        this.Label = "Customer";
        this.CustomerNumber = e;
        this.CustomerZip = t
    }
}
if (typeof MGX.Contact !== "function") {
    MGX.Contact = function(e, t, n, r, i) {
        this.Label = "Contact";
        this.EmailAddress = MGX.IsDefined(e);
        this.MobilePhone = MGX.IsDefined(t);
        this.CatalogRequest = MGX.IsDefined(n);
        this.InputFrom = MGX.IsDefined(r);
        this.List = MGX.IsDefined(i)
    }
}

if (typeof MGX.Visitaction !== "function") {
    MGX.Visitaction = function(e, t, n, r) {
        this.Label = "Visitaction";
        this.VisitType = MGX.IsDefined(e);
        this.VisitKey = MGX.IsDefined(t);
        this.ActionType = MGX.IsDefined(n);
        this.ActionKey = MGX.IsDefined(r);
        
    }
}


if (typeof MGX.OptOut !== "function") {
    MGX.OptOut = function(e, t, n) {
        this.Label = "OptOut";
        this.EmailAddress = MGX.IsDefined(e);
        this.MobilePhone = MGX.IsDefined(t);
        this.List = MGX.IsDefined(n)
    }
}
if (typeof MGX.Search !== "function") {
    MGX.Search = function(e, t, n) {
        this.Label = "Search";
        this.SearchPhrase = MGX.IsDefined(e);
        this.ItemCount = MGX.IsDefined(t);
        this.ItemsShown = MGX.IsDefined(n)
    }
}
if (typeof MGX.Product !== "function") {
    MGX.Product = function(e, t, n, r, i, s, o, u, a) {
        this.Label = "Product";
        this.Sku = MGX.IsDefined(e);
        this.ProductName = MGX.IsDefined(t);
        this.ImagePath = MGX.IsDefined(n);
        this.StockStatus = MGX.IsDefined(r);
        this.CrossSells = MGX.IsDefined(i);
        this.ReviewStars = MGX.IsDefined(s);
        this.ReviewCount = MGX.IsDefined(o);
        this.AltImageCount = MGX.IsDefined(u);
        this.HasVideo = MGX.IsDefined(a)
    }
}
if (typeof MGX.Category !== "function") {
    MGX.Category = function(e, t, n, r) {
        this.Label = "Category";
        this.CategoryId = MGX.IsDefined(e);
        this.CategoryName = MGX.IsDefined(t);
        this.ImagePath = MGX.IsDefined(n);
        this.ItemsShown = MGX.IsDefined(r)
    }
}
if (typeof MGX.CheckoutVisit !== "function") {
    MGX.CheckoutVisit = function(e) {
        this.Label = "CheckoutVisit";
        this.ShippingCost = MGX.IsDefined(e)
    }
}
if (typeof MGX.CheckoutComplete !== "function") {
    MGX.CheckoutComplete = function(e, t) {
        this.Label = "CheckoutComplete";
        this.OrderId = MGX.IsDefined(e);
        this.OrderTotal = MGX.IsDefined(t)
    }
}
if (typeof MGX.Cart !== "function") {
    MGX.Cart = function(e, t) {
        this.Label = "Cart";
        this.CartId = MGX.IsDefined(e);
        this.CartItems = MGX.IsDefined(t)
    }
}
if (typeof MGX.CartItem !== "function") {
    MGX.CartItem = function(e, t, n, r, i) {
        this.Label = "CartItem";
        this.Sku = MGX.IsDefined(e);
        this.ProductName = MGX.IsDefined(t);
        this.Quantity = MGX.IsDefined(n);
        this.UnitPrice = MGX.IsDefined(r);
        this.ImagePath = MGX.IsDefined(i)
    }
}
if (typeof MGX.HandleContacts !== "function") {
    MGX.HandleContacts = function(e) {
        var t = jQuery("input[name]").filter(function() {
            return this.name.toLowerCase().indexOf("email") != -1
        });
        jQuery.each(t, function(t, n) {
            jQuery(n).blur(function() {
                if (jQuery(this).val().indexOf("@") != -1) {
                    var t = jQuery(n).parent();
                    var r = jQuery(t).is("[id]") ? ":" + jQuery(t).attr("id") : jQuery(t).is("[name]") ? ":" + jQuery(t).attr("name") : "";
                    var i = MGX.IsDefined(MGX.GetCookie("mgxContactData"));
                    var s = MGX.IsDefined(MGX.GetCookie("mgxContactFrom"));
                    var o = i != "" ? "|" : "";
                    if (i.indexOf(jQuery(this).val()) == -1) {
                        MGX.SetCookie("mgxContactData", i + o + jQuery(this).val(), null);
                        MGX.SetCookie("mgxContactFrom", s + o + e + r, null)
                    }
                }
            })
        });
        var n = MGX.IsDefined(MGX.GetCookie("mgxContactData")).split("|");
        var r = MGX.IsDefined(MGX.GetCookie("mgxContactFrom")).split("|");
        jQuery.each(n, function(e, t) {
            if (t.indexOf("@") != -1) {
                var n = e < r.length ? r[e] : "";
                MGX.Commit(new MGX.Contact(t, "", "", n, ""))
            }
        });
        MGX.SetCookie("mgxContactData", "", null);
        MGX.SetCookie("mgxContactFrom", "", null)
    }
}
if (typeof MGX.HandleContactsWithAddress !== "function") {
    MGX.HandleContactsWithAddress = function(e) {
        MGX.SetCookie("mgxContactAddr", "", null)
    }
}
if (typeof UCX !== "object") {
    UCX = {
        AccessKey: "",
        CookieId: "",
        NewSession: "",
        Keycode: "",
        Uid: "",
        Eid: "",
        Sid: ""
    }
}
if (typeof UCX.GetCookie !== "function") {
    UCX.GetCookie = function(e) {
        var t, n, r, i = document.cookie.split(";");
        for (t = 0; t < i.length; t++) {
            n = i[t].substr(0, i[t].indexOf("="));
            r = i[t].substr(i[t].indexOf("=") + 1);
            n = n.replace(/^\s+|\s+$/g, "");
            if (n == e) {
                return unescape(r)
            }
        }
    }
}
if (typeof UCX.SetCookie !== "function") {
    UCX.SetCookie = function(e, t, n) {
        var r = new Date;
        r.setDate(r.getDate() + n);
        var i = escape(t) + "; path=/" + (n == null ? "" : "; expires=" + r.toUTCString());
        document.cookie = e + "=" + i
    }
}
if (typeof UCX.GetParameter !== "function") {
    UCX.GetParameter = function(e) {
        e = e.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
        var t = "[\\?&]" + e + "=([^&#]*)";
        var n = new RegExp(t);
        var r = n.exec(window.location.search);
        if (r == null) return "";
        else return decodeURIComponent(r[1].replace(/\+/g, " "))
    }
}
if (typeof UCX.ServiceUrl !== "function") {
    UCX.ServiceUrl = function(e) {
        return ""
    }
}
if (typeof UCX.ServiceAction !== "function") {
    UCX.ServiceAction = function(e, t, n, r) {
        return e
    }
}
if (typeof UCX.Init !== "function") {
    UCX.Init = function() {
        var e = UCX.GetCookie("UCX_P");
        if (typeof e === "undefined") e = "";
        UCX.CookieId = e;
        return
    }
}
UCX.Init();
if (typeof UCX.P !== "function") {
    UCX.P = function(e, t, n, r, i) {
        UCX_Queue(e, t)
    }
}
if (typeof UCX.U !== "function") {
    UCX.U = function(e, t, n, r, i, s) {
        return
    }
}
if (typeof UCX.LogCustomer !== "function") {
    UCX.LogCustomer = function(e, t, n, r, i) {
        if (typeof i === "undefined") {
            i = ""
        }
        if (i != "") {
            MGX.Keycode = i
        }
        return MGX.Commit(new MGX.Customer(n, r))
    }
}
if (typeof UCX.LogContact !== "function") {
    UCX.LogContact = function(e, t, n, r, i, s, o) {
        if (typeof s === "undefined") {
            s = ""
        }
        if (s != "") {
            MGX.Keycode = s
        }
        if (typeof n === "undefined") {
            n = ""
        }
        if (n != "" && n != "undefined" && n != "Enter email address") {
            return MGX.Commit(new MGX.Contact(n, "", r, i, o))
        }
    }
}
if (typeof UCX.LogOptOut !== "function") {
    UCX.LogOptOut = function(e, t, n, r, i) {
        if (typeof r === "undefined") {
            r = ""
        }
        if (r != "") {
            MGX.Keycode = r
        }
        if (typeof n === "undefined") {
            n = ""
        }
        if (typeof i === "undefined") {
            i = ""
        }
        if (n != "" && n != "undefined" && n != "Enter email address") {
            return MGX.Commit(new MGX.OptOut(n, "", i))
        }
    }
}
if (typeof UCX.LogSearch !== "function") {
    UCX.LogSearch = function(e, t, n, r) {
        return MGX.Commit(new MGX.Search(n, r, ""))
    }
}
if (typeof UCX.LogProductVisit !== "function") {
    UCX.LogProductVisit = function(e, t, n, r, i, s) {
        return MGX.Commit(new MGX.Product(n, encodeURIComponent(r), i, s, "", 0, 0, 0, 0))
    }
}
if (typeof UCX.LogCategoryVisit !== "function") {
    UCX.LogCategoryVisit = function(e, t, n, r, i, s) {
        return MGX.Commit(new MGX.Category(n, encodeURIComponent(r), i, s))
    }
}
if (typeof UCX.LogCheckoutVisit !== "function") {
    UCX.LogCheckoutVisit = function(e, t, n) {
        return MGX.Commit(new MGX.CheckoutVisit(n))
    }
}
if (typeof UCX.LogCheckoutComplete !== "function") {
    UCX.LogCheckoutComplete = function(e, t, n, r) {
        return MGX.Commit(new MGX.CheckoutComplete(n, r))
    }
}
if (typeof UCX.UpdateCart !== "function") {
    UCX.UpdateCart = function(e, t, n, r, i) {
        if (typeof i === "undefined") {
            i = ""
        }
        if (typeof n === "undefined") {
            n = ""
        }
        if (n != "") {
            MGX.Keycode = n
        }
        return MGX.Commit(new MGX.Cart(i, r))
    }
}
if (typeof UCX.RetrieveCart !== "function") {
    UCX.RetrieveCart = function(e, t) {
        return ""
    }
}
if (typeof UCX.CartItem !== "function") {
    UCX.CartItem = function(e, t, n, r, i) {
        this.Sku = e;
        this.ProductName = encodeURIComponent(t);
        this.Quantity = n;
        this.UnitPrice = r;
        this.ImagePath = i
    }
}